module.exports = __webpack_public_path__ + "static/images/dropdown-caret.57d4e9dd4a6df56c2436e08efdacbaa3.svg";